import { makeAuthenticatedRequest } from '../utils/api';

export const getOrganizations = async () => {
	const response = await makeAuthenticatedRequest('/api/organizations');
	return response;
};

export const createOrganization = async (
	name,
	lookerClientName = null,
	lookerDashboardId = null
) => {
	const response = await makeAuthenticatedRequest('/api/organizations', {
		method: 'POST',
		body: JSON.stringify({ name, lookerClientName, lookerDashboardId }),
	});
	return response;
};

export const updateOrganization = async (id, { name, lookerClientName, lookerDashboardId }) => {
	const response = await makeAuthenticatedRequest(`/api/organizations/${id}`, {
		method: 'PUT',
		body: JSON.stringify({ name, lookerClientName, lookerDashboardId }),
	});
	return response;
};

export const deleteOrganization = async id => {
	await makeAuthenticatedRequest(`/api/organizations/${id}`, {
		method: 'DELETE',
	});
};

// ─── Relationship tab (internal only) ─────────────────────────────────────────
// The day rate and the values derived from it are absent from the response unless
// the caller is an admin or superuser, so the view checks for the field rather
// than the role.

export const getOrganizationTerms = async id => {
	const response = await makeAuthenticatedRequest(`/api/organizations/${id}/terms`);
	return response;
};

// Every period write answers with the whole recalculated history, so the caller
// never has to work out which period is current after a change.
export const addOrganizationTermsPeriod = async (id, period) => {
	const response = await makeAuthenticatedRequest(`/api/organizations/${id}/terms/periods`, {
		method: 'POST',
		body: JSON.stringify(period),
	});
	return response;
};

export const updateOrganizationTermsPeriod = async (id, periodId, period) => {
	const response = await makeAuthenticatedRequest(
		`/api/organizations/${id}/terms/periods/${periodId}`,
		{
			method: 'PUT',
			body: JSON.stringify(period),
		}
	);
	return response;
};

export const deleteOrganizationTermsPeriod = async (id, periodId) => {
	const response = await makeAuthenticatedRequest(
		`/api/organizations/${id}/terms/periods/${periodId}`,
		{ method: 'DELETE' }
	);
	return response;
};

// `categories` is an array; an empty array means no filter
export const getOrganizationNotes = async (id, categories = []) => {
	const query = categories.length > 0 ? `?categories=${categories.join(',')}` : '';
	const response = await makeAuthenticatedRequest(`/api/organizations/${id}/notes${query}`);
	return response;
};

export const addOrganizationNote = async (id, { category, body }) => {
	const response = await makeAuthenticatedRequest(`/api/organizations/${id}/notes`, {
		method: 'POST',
		body: JSON.stringify({ category, body }),
	});
	return response;
};

export const deleteOrganizationNote = async (id, noteId) => {
	await makeAuthenticatedRequest(`/api/organizations/${id}/notes/${noteId}`, {
		method: 'DELETE',
	});
};
